/**
 * Nikura storefront analytics integrations.
 *
 * Keep third-party analytics/bootstrap loaders in this shared asset rather than
 * creating one theme asset per provider. Feature-specific event tracking stays
 * in its owning EQ component (for example, eq-pdp-tracking.js).
 */

/**
 * Hextom FSB metadata — parity with the current live Nikura theme.
 *
 * The Liquid snippet emits inert JSON so authored Liquid contains no executable
 * custom JavaScript. This file is loaded with `defer` for page speed, so it runs
 * after content_for_header: an app loader that reads window.hextom_fsb_meta
 * synchronously while parsing will not see it yet (see CLAUDE.md §4).
 */
(function initializeHextomFsbMeta(w, d) {
  const source = d.querySelector('[data-eq-hextom-fsb-meta]');
  if (!source) return;

  try {
    w.hextom_fsb_meta = JSON.parse(source.textContent || '{}');
  } catch (error) {
    console.error('Unable to initialize Hextom FSB metadata.', error);
  }
})(window, document);

// Google Tag Manager — parity with the current live Nikura theme.
(function loadGoogleTagManager(w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const firstScript = d.getElementsByTagName(s)[0];
  const script = d.createElement(s);
  const dataLayerParam = l !== 'dataLayer' ? `&l=${l}` : '';

  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dataLayerParam}`;
  script.crossOrigin = 'anonymous';

  firstScript.parentNode.insertBefore(script, firstScript);
})(window, document, 'script', 'dataLayer', 'GTM-N966RNK');

// Microsoft Clarity and Heatmap.com load from `eq-session-recorders.js`, linked earlier in `<head>`.

// Northbeam — parity with the current live Nikura theme.
(function loadNorthbeam(w, d) {
  const queue = [];

  const enqueue = (fnName, ...args) => {
    queue.push({ fnName, args });
  };

  w.Northbeam = {
    _q: queue,
    identify: (customerId, properties) => enqueue('identify', customerId, properties),
    trackPageView: () => enqueue('trackPageView'),
    fireEmailCaptureEvent: (email, properties) => enqueue('fireEmailCaptureEvent', email, properties),
    fireCustomGoal: (goalName, properties) => enqueue('fireCustomGoal', goalName, properties),
    firePurchaseEvent: (purchase) => enqueue('firePurchaseEvent', purchase),
  };

  const script = d.createElement('script');
  script.async = true;
  // No crossOrigin: Northbeam sends no Access-Control-Allow-Origin, so a CORS request is blocked.
  script.src = 'https://j.northbeam.io/ota-sp/e7466be2-e64f-42b2-9093-b6dafd9fdff5.js';

  d.head.appendChild(script);
})(window, document);
